import { Skeleton } from '@cko/primitives';
import styled from 'styled-components';
export const StyledSkeleton = styled(Skeleton) `
  width: 100px;
`;
